/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { FieldFabFamilyInformation } from '../../components/add-family-information/field-fab-family-information/field-fab-family-information.component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class FieldFabFamilyInformationDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = FieldFabFamilyInformation;
    sysquePopupConfig.width = 1280;
      sysquePopupConfig.height = 815;
    sysquePopupConfig.componentTitle = '';
    sysquePopupConfig.visible = true;
  }
}
